
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionFeatureConfigs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FeatureConfigs"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"optimizelyLocationMatch"},"name":{"kind":"Name","value":"optimizelyPages"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"optimizelyEnabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"optimizelyEventSafelist"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"optimizelyPropertySafelist"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"newRelicEnabled"},"name":{"kind":"Name","value":"newrelicBrowserEnabled"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"pxSensorScriptEnabled"},"name":{"kind":"Name","value":"corgiPerimeterxSensorScriptEnabled"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"membershipEnabled"},"name":{"kind":"Name","value":"enableSubscriptionsFor"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"showBlackHistoryLogo"},"name":{"kind":"Name","value":"enableBlackHistoryLogo"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"showPrideLogo"},"name":{"kind":"Name","value":"enablePrideLogo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amplitudeSessionReplayConfig"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maintenanceBanner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tosLegalNoticeBanner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tosLegalNoticeBannerCopy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryBanner"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":500}};
    doc.loc.source = {"body":"fragment SessionFeatureConfigs on FeatureConfigs {\n\toptimizelyLocationMatch: optimizelyPages\n\toptimizelyEnabled\n\toptimizelyEventSafelist\n\toptimizelyPropertySafelist\n\tnewRelicEnabled: newrelicBrowserEnabled\n\tpxSensorScriptEnabled: corgiPerimeterxSensorScriptEnabled\n\tmembershipEnabled: enableSubscriptionsFor\n\tshowBlackHistoryLogo: enableBlackHistoryLogo\n\tshowPrideLogo: enablePrideLogo\n\tamplitudeSessionReplayConfig\n\tmaintenanceBanner\n\ttosLegalNoticeBanner\n\ttosLegalNoticeBannerCopy\n\tcountryBanner\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SessionFeatureConfigs"] = oneQuery(doc, "SessionFeatureConfigs");
        
